import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { getItemBySlug } from 'Services/connectors';
import { getProject } from 'Services/project';
import DeleteButton from '../../../common/components/DeleteButton';
import Layout from '../../../common/components/Layout';
import ReturnButton from '../../../common/components/ReturnButton';
import { SimpleBreadcrumbs } from '../../../common/components/SimpleBreadcrumbs';
import TabsRoute from '../../../common/components/TabsRoute';
import { UserRestriction } from '../../../common/components/UserRestiction';
import { deleteBroadcast, fetchBroadcast, updateBroadcast } from '../actions';
import BroadcastForm from './Form';

@injectIntl
@connect((store, props) => ({
  slug: props.match.params.topicSlug,
  broadcast: getItemBySlug(store.broadcast, props.match.params.topicSlug),
  fetching: store.broadcast.fetching,
}))
export default class Detail extends Component {
  menu = [{ label: 'app_broadcastInfo', link: '/' }];

  componentDidMount() {
    this.fetchData();
  }

  UNSAFE_componentWillReceiveProps(next) {
    if (next.slug != this.props.slug) {
      this.fetchData(next.slug);
    }
  }

  fetchData = targetSlug => {
    const { slug, dispatch } = this.props;
    dispatch(fetchBroadcast(targetSlug || slug));
  };

  handleBroadcastChange = bc => {
    const { dispatch } = this.props;
    return dispatch(updateBroadcast(bc.id, bc));
  };

  handleRemove = () => {
    const { broadcast, dispatch, history } = this.props;
    return dispatch(deleteBroadcast(broadcast.id)).then(() => {
      history.push(`${getProject().url}/broadcasts`);
    });
  };

  render() {
    const {
      fetching,
      broadcast,
      match,
      history,
      intl: { messages: m },
    } = this.props;

    if (fetching) {
      return <CircularProgress size={100} style={{ width: 100, margin: 'auto' }} />;
    }
    if (!broadcast) {
      return <div>{m.error_noData}</div>;
    }

    return (
      <Layout
        id="broadcast-layout"
        top={
          <SimpleBreadcrumbs
            crumbStack={[
              {
                labelKey: 'app_broadcasts',
                href: `#${getProject().url}/broadcasts`,
              },
              { label: broadcast.name },
            ]}
          />
        }
        main={
          <Paper elevation={2}>
            <Toolbar>
              <Typography variant="h6">
                {broadcast.name || `${m.app_broadcast}: ${broadcast.id}`}
              </Typography>
              <div style={{ flex: 1 }} />
              <UserRestriction>
                <DeleteButton onRemove={this.handleRemove} />
              </UserRestriction>
              <ReturnButton entity="broadcasts" />
            </Toolbar>

            <TabsRoute match={match} menu={this.menu} history={history} />
            <Route
              exact
              path={match.url}
              render={() => (
                <BroadcastForm onSubmit={this.handleBroadcastChange} data={broadcast} />
              )}
            />
          </Paper>
        }
      />
    );
  }
}
